import { createSlice } from "@reduxjs/toolkit";

const intiPageState = { page: 1, pageSize: 50 };

const initialState = {
  farmer: intiPageState,
  web: intiPageState,
  mobile: intiPageState,
  warehouse: intiPageState,
  crop: intiPageState,
  variety: intiPageState,
  grade: intiPageState,
  category: intiPageState,
  product: intiPageState,
  vendor: intiPageState,
  roles: intiPageState,
  city: intiPageState,
  country: intiPageState,
  state: intiPageState,
  district: intiPageState,
  procLimitApproval: intiPageState,
  procPaymentApproval: intiPageState,
  procPaymentCbzFbc: intiPageState,
  procPaymentEcocash: intiPageState,
  procPaymentCash: intiPageState,
  procReconcileCbzFbc: intiPageState,
  procReconcileEcocash: intiPageState,
  vendorProcessFee: intiPageState,
  farmerReconcile: intiPageState,
  procReport: intiPageState,
  procLimitApprovalReport: intiPageState,
  procPaymentApprovalReport: intiPageState,
  procPaymentReport: intiPageState,
  procPayStatusReport: intiPageState,
  procReconcileReport: intiPageState,
  vendorPaymentReport: intiPageState,
  vendorProcessFeeReport: intiPageState,
  procPaySuccessReport: intiPageState,
  foProcReport: intiPageState,
  intFundTransReport: intiPageState,
  logRequestResponseReport: intiPageState,
  vendorRemittance: intiPageState,
  vendorRemittanceReport: intiPageState,
  procPaySummaryReport: intiPageState,
  voucherReport: intiPageState,
  voucherApprovalReport: intiPageState,
  voucherAuthenticateReport: intiPageState,
  voucherApproval: intiPageState,
  voucherAuthenticate: intiPageState,
  stockReport: intiPageState,
  stockEntryReport: intiPageState,
  stockDistributionReport: intiPageState,
  stopOrderPush: intiPageState,
  stopOrderPushReport: intiPageState,
  farmVisitReport: intiPageState,
  document: intiPageState,
  farm: intiPageState,
  farmCrop: intiPageState,
  procAccountAuditApproval: intiPageState,
  procAccountAuditApprovalReport: intiPageState,
  ledgerEntReport: intiPageState,
};

export const pageSlice = createSlice({
  name: "pageSlice",
  initialState,
  reducers: {
    setPages: (state, action) => {
      const {
        payload: { type, page, pageSize },
      } = action;
      let pageState = { ...state[type] };
      if (page) {
        pageState = { ...pageState, page };
      }
      if (pageSize) {
        pageState = { ...pageState, pageSize };
      }
      state[type] = pageState;
    },
    resetPages: () => {
      return initialState;
    },
  },
});

export const { setPages, resetPages } = pageSlice.actions;

export default pageSlice.reducer;
